import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";

import { toastr } from "react-redux-toastr";
import label from "../../labels/accessRightsManagement_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import {
  getDepartmentList,
  saveDepartmentData,
} from "../../actions/accessRightsManagementActions";
import DeleteDepartment from "./deleteDepartment";
import UpdateDepartment from "./updateDepartment";
import TablePagination from "../../../common/components/TablePagination";
const DefineDepartment = () => {
  const { handleSubmit, errors, register, reset } = useForm({
    mode: "onChange",
  });
  const [departmentName, setDepartmentName] = useState("");
  const [departmentDescription, setDepartmentDescription] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [stepName, setName] = useState("AddDepartment");
  const [checkboxData, setCheckBoxData] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [deleteData, setDeleteData] = useState("");
  const [updateData, setUpdateData] = useState("");
  let [listCurrentPage, setListCurrentPage] = useState(0);

  const session = JSON.parse(sessionStorage.getItem("session"));
  // const [departmentList,setDeparmentList]=useState();
  const dispatch = useDispatch();

  let rowPerPage = 10;
  useEffect(() => {
    window.scrollTo(0, 0);
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let { departmentList } = useSelector(
    (state) => state?.accessRightsManagementReducer,
    shallowEqual
  );
  useEffect(() => {
    if (stepName == "DepartmentList") {
      dispatch(getDepartmentList());
      // setDeparmentList(getdepartmentList)
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);
  const onCancelButton = () => {
    reset();
    setReloadItem(!reloadItem);
  };
  const onSubmit = () => {
    if (departmentName !== "" && departmentDescription !== "") {
      let data = {
        name: departmentName,
        description: departmentDescription,
        isActive: checkboxData,
        isDeleted: "false",
      };
      dispatch(saveDepartmentData(data, onCancelButton));
      // onCancelButton();
    } else {
      toastr.error(label.ErrorForRequireFields);
    }
  };
  const onChangeDepartmentDescription = (val) => {
    setDepartmentDescription(val);
    // if (+val === +val) { // if is a number
    // }
  };

  const editUser = (val) => {
    setShowEditModal(true);
    setUpdateData(val);
  };

  const deleteUser = (val) => {
    setShowDeleteModal(true);
    setDeleteData(val);
  };

  const onhandleisActive = (ele) => {
    setCheckBoxData(ele.target.checked);
  };

  const handleActive = (roleId, isActive) => {
    let data = {
      id: roleId,
      isActive: !isActive
    };
    dispatch(saveDepartmentData(data, onCancelButton));
  };

  return (
    <div className="dashboardContentArea">
      <h5 className="labelMargin"> {label.DefineDepartment} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "AddDepartment"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="AddDepartment"
              id="AddDepartment-tab"
              onClick={() => setName("AddDepartment")}
              data-toggle="tab"
              role="tab"
              aria-controls="AddDepartment"
              aria-selected="false"
            >
              <span>{label.AddDepartment}</span>
            </a>
          </li>
          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "DepartmentList"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="DepartmentList"
              id="unapproved-tab"
              onClick={() => setName("DepartmentList")}
              data-toggle="tab"
              role="tab"
              aria-controls="DepartmentList"
              aria-selected="false"
            >
              <span>{label.DepartmentList}</span>
            </a>
          </li>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "AddDepartment"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="AddDepartment"
            role="tabpanel"
            aria-labelledby="list-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="defineDepartmentForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row">
                      <div className="col-md-3">
                        <label className="float-left">
                          {label.DepartmentName}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="text"
                          name="departmentName"
                          onChange={(e) => {
                            setDepartmentName(e.target.value);
                          }}
                          className="form-control"
                          maxLength={25}
                          ref={register({ required: true })}
                        />
                        {_.get("departmentName.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 ">
                        <label className="float-left">
                          {label.Description}
                          <span className="errorText">*</span>
                        </label>
                        <textarea
                          name="departmentdescription"
                          onChange={(e) => {
                            onChangeDepartmentDescription(e.target.value);
                          }}
                          className="form-control "
                          ref={register({
                            required: true,
                            pattern: {
                              value: /^(?:(?!\s{2}).)*$/,
                            },
                          })}
                          maxLength={100}
                          rows={3}
                        />
                        {_.get("departmentdescription.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        {_.get("departmentdescription.type", errors) ===
                          "pattern" && (
                            <p className="errorText float-left">
                              {commonLabels.InputInvalid}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-3">
                        <label className="float-left">
                          {label.isActive}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="checkbox"
                          id="isActive"
                          name="isActive"
                          // defaultChecked={updatedValue?.user?.isActive}
                          // className="form-control"
                          // ref={register({ required: true })}
                          checked={checkboxData}
                          onChange={(event) => onhandleisActive(event)}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6 ">
                        {session.roleName === "superadmin" && (
                          <>
                            <button
                              type="reset"
                              className="btn btn-secondary mr-2 mt-10 ml-10"
                              onClick={() => onCancelButton()}
                            >
                              {commonLabels.BUTTON_CANCEL}
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary mr-2 mt-10"
                              onClick={handleSubmit((e) => {
                                onSubmit(e);
                              })}
                            >
                              {commonLabels.BUTTON_SAVE}
                            </button>{" "}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "DepartmentList"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="DepartmentList"
            role="tabpanel"
            aria-labelledby="DepartmentList-tab"
          >
            {departmentList && departmentList.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      <th className="text-center col-1">{label.Srno}</th>
                      <th className="col-3">
                        {label.DepartmentName}
                      </th>
                      <th className="col-6">{label.Description}</th>
                      <th className="text-center col-1">{label.Action}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {departmentList &&
                      departmentList.length > 0 &&
                      departmentList
                        .filter((ele) => ele.isDeleted == false)
                        .map((item, index) => {
                          return (
                            <tr key={index}>
                              <td className="text-center">{index + 1}</td>
                              <td >{item.name}</td>
                              <td >
                                {item.description}
                              </td>
                              {/* <td className="text-center">
                                <div className="d-flex">
                                  <button
                                    type="button"
                                    className="btn btn-primary mr-2"
                                    onClick={() => editUser(item)}
                                  >
                                    Edit
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary "
                                    onClick={() => deleteUser(item)}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </td> */}
                              <td className="col-2 text-center">
                                <i
                                  role="button"
                                  data-toggle="tooltip"
                                  title="Edit"
                                  className={"text-primary fa fa-edit fa-lg"}
                                  onClick={() => editUser(item)}
                                ></i>
                                &nbsp;&nbsp;
                                <i role="button"
                                  data-toggle="tooltip"
                                  title={item.isActive ? commonLabels.BUTTON_INACTIVE : commonLabels.BUTTON_ACTIVE}
                                  className={item.isActive === true ? "text-success fa fa-toggle-on fa-lg" : "text-danger fa fa-toggle-off fa-lg"}
                                  onClick={() => { handleActive(item.id, item.isActive); }}>
                                </i>
                                &nbsp;&nbsp;
                                <i
                                  role="button"
                                  data-toggle="tooltip"
                                  title="Delete"
                                  className={"text-danger fa fa-trash fa-lg"}
                                  onClick={() => deleteUser(item)}
                                ></i>
                              </td>
                            </tr>
                          );
                        })}
                  </tbody>
                </table>
                {/* <TablePagination
                  paginationFor="un_verion_mismatch_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  totalCount={getdepartmentList.totalNoOfRecords}
                /> */}
                {showDeleteModal && (
                  <DeleteDepartment
                    setShowDeleteModal={setShowDeleteModal}
                    showDeleteModal={showDeleteModal}
                    setDeleteData={deleteData}
                  />
                )}
                {showEditModal && (
                  <UpdateDepartment
                    setShowEditModal={setShowEditModal}
                    showEditModal={showEditModal}
                    setUpdateData={updateData}
                  />
                )}
              </>
            ) : (
              <div className="text-center">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )} 
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefineDepartment;
